import EventManager from "../store/sqftEventManager";
import PointV2, {CORE_POINT_LAYOUTS} from "../core/shapes/pointV2";
import workspace from "../core/workspace";
import sqftConfig from "../store/sqftConfig";
import {
  getAngleRelativeToTheHorizontalAxis,
  getMousePositionOnField,
  getPointDistance
} from "../../../helpers/sqftHelper";

/**
 * @return {PointV2}
 */
export const getFreeDrawPoint = (pos) => {
  let pointState = {
    priority: EventManager.priorities.BOX_POINT,
    movable: true,
    isCentered: true,
    isResizedByPoint: false,
    isScaledByPoint: false,
    isVisibleOnHover: false
  };
  let pointDesign = {
    radius: 10,
    lineWidth: 1,
    layout: CORE_POINT_LAYOUTS.black
  };
  let wPos = workspace.getPosition();
  let scale = sqftConfig.scale;
  let offset = {
    x: (pos.x + wPos.x) / scale,
    y: (pos.y + wPos.y) / scale
  };

  return new PointV2(offset.x, offset.y, workspace, pointState, pointDesign);
}

export const getLockedPoint = (existingPoint, pos, lockedAngleStep) => {
  const newPoint = getFreeDrawPoint(pos);
  const lockedPosition = getLockPointPos(existingPoint, lockedAngleStep);
  const lockedPositionOnField = getMousePositionOnField(lockedPosition.x, lockedPosition.y);
  newPoint.setPosition(lockedPositionOnField);

  return newPoint
}

/**
 * works only for 90 deg angle
 * @param pointV2
 * @param angleStep
 * @param mousePos
 * @return {{x: int, y: int}}
 */
export const getLockPointPos = (pointV2, angleStep = 90, mousePos = EventManager.LastKnownMousePos) => {
  const pointV2PointField = pointV2.getPointField();

  let rotateToMouseAngle = getAngleRelativeToTheHorizontalAxis(mousePos, pointV2PointField);
  let lineLength = getPointDistance(pointV2PointField, mousePos);
  const closestAngle = Math.round(rotateToMouseAngle / angleStep) * angleStep;
  const angleRad = (closestAngle * Math.PI) / 180;

  return {
    x: pointV2PointField.x + lineLength * Math.cos(angleRad),
    y: pointV2PointField.y + lineLength * Math.sin(angleRad)
  };
};
